import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import withLoader from "../../../components/layouts/WithLoader";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DataListProductDetails from "./DataListProductDetails";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import UtilsFormule from "../../../utils/UtilsFormule";

const DetailsInventaire = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [inventaireWarehouse, setInventaireWarehouse] = useState();
  const [products, setProducts] = useState([]);

  const [notAddedProducts, setNotAddedProducts] = useState([]);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  useEffect(() => {
    startLoading();
    WarehouseService.getInventaireById(
      getCurrentUserId(),
      localStorage.getItem("idInvntaireWarehouse")
    )
      .then((response) => {
        if (response.data.success) {
          setInventaireWarehouse(response.data.success);
          setProducts(response.data.success.products || []);
          setNotAddedProducts(response.data.success.notAddedProducts || []);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : inventaire introuvable");
        }
      })
      .catch((e) => {
        console.log("error in getInventaireById", e);
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      })
      .finally(() => {
        stopLoading();
      });
  }, []);


  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (
          response.headers["content-type"] ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          const file = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const excelWindow = window.open();
          excelWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };
  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenErrorAlert(false);
  };

  const sumEcart = (list, sign) =>
    (list || []).reduce((sum, p) => {
      const v = Number(p.ecartQuantity) || 0;
      return sign > 0 ? sum + (v > 0 ? v : 0) : sum + (v < 0 ? -v : 0);
    }, 0);
  const surplus = sumEcart(products, 1);
  const manque = sumEcart(products, -1);

  const infoItems = inventaireWarehouse
    ? [
        {
          icon: "fas fa-warehouse",
          label: "Dépôt",
          value: `${inventaireWarehouse?.refWarehouse || ""}-${
            inventaireWarehouse?.nameWarehouse || ""
          }`,
        },
        {
          icon: "fas fa-calendar-plus",
          label: "Date de création",
          value: UtilsFormule.formatDateHours(inventaireWarehouse?.creationDate),
        },
        {
          icon: "fas fa-user",
          label: "Utilisateur",
          value: `${inventaireWarehouse?.userInventaire?.firstName || ""} ${
            inventaireWarehouse?.userInventaire?.lastName || ""
          }`,
        },
        {
          icon: "fas fa-calendar-check",
          label: "Date d'inventaire",
          value: UtilsFormule.formatDateHours(inventaireWarehouse?.inventaireDate),
        },
      ]
    : [];

  const kpis = [
    { label: "Produits ajoutés", value: products.length, icon: "fas fa-check-circle", color: "#28a745" },
    { label: "Produits non ajoutés", value: notAddedProducts.length, icon: "fas fa-minus-circle", color: "#6c757d" },
    { label: "Surplus total", value: `+${surplus}`, icon: "fas fa-arrow-up", color: "#28a745" },
    { label: "Manque total", value: `-${manque}`, icon: "fas fa-arrow-down", color: "#dc3545" },
  ];

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-clipboard-check mr-2"></i>Détails de
                l'inventaire
                {inventaireWarehouse && (
                  <span className="badge badge-dark ml-2">
                    {inventaireWarehouse?.ref}-{inventaireWarehouse?.year}
                  </span>
                )}
              </h4>
              <small className="text-muted">
                Écarts constatés entre le stock du système et le comptage
              </small>
            </div>
            <div className="mt-2 mt-sm-0">
              {inventaireWarehouse?.urlFileInventaire && (
                <button
                  className="btn btn-outline-dark mr-2"
                  onClick={() =>
                    onShowFileInOtherWizndowHandler(
                      inventaireWarehouse?.urlFileInventaire
                    )
                  }
                >
                  <i className="fas fa-file-alt mr-1"></i>
                  Voir le fichier
                </button>
              )}
              <button
                className="btn btn-outline-secondary"
                onClick={() => navigate("/inventaires")}
              >
                <i className="fas fa-arrow-left mr-1"></i>
                Retour aux inventaires
              </button>
            </div>
          </div>
        </div>
      </section>

      {inventaireWarehouse != null && (
        <section className="content">
          <div className="container-fluid">
            <div className="row mt-3">
              {infoItems.map((item) => (
                <div className="col-xl-3 col-md-6" key={item.label}>
                  <div
                    className="d-flex align-items-center p-3 mb-3 bg-white"
                    style={{ ...cardStyle, borderLeft: "4px solid #343a40" }}
                  >
                    <span
                      className="d-flex align-items-center justify-content-center bg-dark text-white mr-3"
                      style={{ width: 44, height: 44, borderRadius: 8, flexShrink: 0 }}
                    >
                      <i className={item.icon}></i>
                    </span>
                    <div style={{ minWidth: 0 }}>
                      <small
                        className="text-muted text-uppercase d-block"
                        style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                      >
                        {item.label}
                      </small>
                      <strong className="d-block text-truncate" title={item.value}>
                        {item.value}
                      </strong>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="row">
              {kpis.map((k) => (
                <div className="col-xl-3 col-md-6" key={k.label}>
                  <div
                    className="d-flex align-items-center p-3 mb-3 bg-white"
                    style={{ ...cardStyle, borderLeft: `4px solid ${k.color}` }}
                  >
                    <span
                      className="d-flex align-items-center justify-content-center text-white mr-3"
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: 8,
                        backgroundColor: k.color,
                        flexShrink: 0,
                      }}
                    >
                      <i className={k.icon}></i>
                    </span>
                    <div>
                      <small
                        className="text-muted text-uppercase d-block"
                        style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                      >
                        {k.label}
                      </small>
                      <span style={{ fontSize: "1.4rem", fontWeight: 700 }}>
                        {k.value}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {products.length > 0 && (
              <div className="card card-outline card-dark" style={cardStyle}>
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-check-circle mr-2"></i>Les produits
                    ajoutés
                    <span className="badge badge-dark ml-2">{products.length}</span>
                  </h3>
                </div>
                <div className="card-body">
                  <DataListProductDetails listProducts={products} />
                </div>
              </div>
            )}

            {notAddedProducts.length > 0 && (
              <div className="card card-outline card-secondary" style={cardStyle}>
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-minus-circle mr-2"></i>Les produits non
                    ajoutés
                    <span className="badge badge-secondary ml-2">
                      {notAddedProducts.length}
                    </span>
                  </h3>
                </div>
                <div className="card-body">
                  <DataListProductDetails listProducts={notAddedProducts} />
                </div>
              </div>
            )}
          </div>
        </section>
      )}

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={3000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(DetailsInventaire);
